// src/pages/PrivacyPolicyPage.js
import React from 'react';
import PrivacyPolicy from '../components/PrivacyPolicy'; // Assuming you moved the original to components

function PrivacyPolicyPage() {
    return <PrivacyPolicy />;
}

export default PrivacyPolicyPage;